import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Grid} from '../../../../shared/Models/grid';
import {Pagination} from '../../../../shared/Models/Pagination';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {
  DateColumn,
  NumberColumn,
  TextColumn
} from '../../../../shared/Models/columns';
import {Helper} from '../../../../helpers/helper.service';
import {HttpParams} from '@angular/common/http';
import {GridComponent} from '../../../../shared/components/grid/grid.component';

class SearchQuery {
  public page = 1;
  public limit = '10';
  public offset = 0;
  public count = 0;
  public sortType: string;
  public sortBy: string;
  public query = '';
  public search = [];
  public status;
  public invoiceStatus;
  public isCredit;
  public backofficeInvoiceStatus;

  intLimit() {
    return parseInt(this.limit);
  }
}

@Component({
  selector: 'app-order-grid',
  templateUrl: './order-grid.component.html',
  styleUrls: ['./order-grid.component.scss', '../../../../../assets/icon/icofont/css/icofont.scss']
})

export class OrderGridComponent implements OnInit, OnChanges {

  public static interval = null;
  public disabledPosition = false;
  public locale = 'en';
  tempSearchBody;
  columns = [];
  wrapperWidth = 0;
  clientWidth = 0;
  loadingIndicator = true;
  searchQuery: SearchQuery = new SearchQuery();
  pagination: Pagination<any> = new Pagination<any>();

  @ViewChild('gridRow', {static: false})
  gridRow: ElementRef;

  @ViewChild('gridSystem', {static: false}) 
  table: DatatableComponent;

  @ViewChild('tableWrapper', {static: false})
  tableWrapper;

  @ViewChild('boolColumnVal', {static: true})
  boolColumnVal: TemplateRef<any>;

  @ViewChild('boolColumnHeader', {static: true})
  boolColumnHeader: TemplateRef<any>;

  @ViewChild('textColumnVal', {static: true})
  textColumnVal: TemplateRef<any>;

  @ViewChild('textColumnHeader', {static: true})
  textColumnHeader: TemplateRef<any>;

  @ViewChild('numberColumnVal', {static: true})
  numberColumnVal: TemplateRef<any>;

  @ViewChild('numberColumnHeader', {static: true})
  numberColumnHeader: TemplateRef<any>;

  @Input() grid: Grid;
  @Input() buttonViewChange = false;
  @Input() removeSelected;
  @Input() cancelMode: boolean;

  @Output()
  sendParameters: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  totalCount: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private broadcastService: BroadcastService,
    @Inject(ElementRef) public el: ElementRef
  ) {
    this.wrapperWidth = el.nativeElement.offsetWidth;
  }

  ngOnInit(): void {
  }

  private setColumns(width) {
    this.columns = [];
    for (let _i = 0; _i < this.grid.columns.length; _i++) {
      switch (this.grid.columns[_i].type) {

        case TextColumn.type:
          this.grid.columns[_i].cellTemplate = this.textColumnVal;
          this.grid.columns[_i].headerTemplate = this.textColumnHeader;
          if (this.grid.columns[_i]['allowAdvance'] || this.grid.columns[_i]['allowAdvanceShowCallback']) {
            this.grid.columns[_i]['searchAdvance'] = [];
          }
          break;
        case NumberColumn.type:
          this.grid.columns[_i].cellTemplate = this.numberColumnVal;
          this.grid.columns[_i].headerTemplate = this.numberColumnHeader;
          break;
        default:
          this.grid.columns[_i].headerTemplate = this.textColumnHeader;
          this.grid.columns[_i].cellTemplate = this.textColumnVal;
      }
      if (this.grid.columns[_i].responsiveHideCallback) {

        if (!this.grid.columns[_i].responsiveHideCallback(width)) {
          for (const item in this.searchQuery.search) {
            if (this.searchQuery.search[item].name === this.grid.columns[_i]['prop']) {
              this.grid.columns[_i]['searchVal'] = this.searchQuery.search[item].value;
            }
          }
          this.columns.push(Object.assign({}, this.grid.columns[_i]));
        }
      } else {
        for (const item in this.searchQuery.search) {
          if (this.searchQuery.search[item] && this.searchQuery.search[item].name === this.grid.columns[_i]['prop']) {
            this.grid.columns[_i]['searchVal'] = this.searchQuery.search[item].value;
            if (this.grid.columns[_i]['type'] === DateColumn.type) {
              this.grid.columns[_i]['dateReferenceFrom'] = this.searchQuery.search[item].value['from'];
              this.grid.columns[_i]['dateReferenceTo'] = this.searchQuery.search[item].value['to'];
            }
          }
        }
        this.columns.push(Object.assign({}, this.grid.columns[_i]));
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.grid.defaultSort) {
      this.searchQuery.sortBy = this.grid.defaultSort;
      if (this.grid.defaultSortType) {
        this.searchQuery.sortType = this.grid.defaultSortType;
      } else {
        this.searchQuery.sortType = 'desc';
      }
    }
    if (!Helper.isDefined(this.grid.root)) {
      this.grid.root = 'data';
    }

    this.setColumns(window.innerWidth);
    this.sendRequest(null);
    this.broadcastService.on('refreshGrid').subscribe(res => {
      if (res === this.grid.method) {
        this.disabledPosition = true;
        this.setColumns(window.innerWidth);
        this.sendRequest(null);
      }
    });

    if (GridComponent.interval == null) {
      GridComponent.interval = setInterval(function () {
        if (Helper.isDefined(this.table)) {
          this.table.recalculate();
        }

      }, 50);
    }
  }

  public sendRequest($e) {
    this.loadingIndicator = true;
    let searchBody = new HttpParams();

    searchBody = searchBody.set('sortType', this.searchQuery.sortType);
    searchBody = searchBody.set('sortBy', this.searchQuery.sortBy);
    searchBody = searchBody.set('per_page', this.searchQuery.limit + '');
    searchBody = searchBody.set('page', (this.searchQuery.offset + 1) + '');
    this.tempSearchBody = searchBody;
    this.sendParameters.emit(searchBody);

    this.grid.service[this.grid.method](searchBody, this.grid.params).subscribe(res => {
      this.searchQuery.count = res.total;
      this.totalCount.emit(res.total);
      const rows = [];

      if (this.grid.root === 'invoice' || this.grid.root === 'order') {
        for (const item of res['data']) {
          if (Helper.isDefined(item['orderItemCollections'])) {
            item[this.grid.root]['orderItemCollections'] = item['orderItemCollections'];
          }
          rows.push(item[this.grid.root]);
        }
      } else {
        for (const item of res[this.grid.root]) {
          rows.push(item);
        }
      }
      this.pagination.data = rows;
      this.loadingIndicator = false;
      this.disabledPosition = false;
    });
  }

  onSort($e) {
    this.searchQuery.sortType = $e.newValue;
    this.searchQuery.sortBy = $e.column.prop;
    this.sendRequest(null);
  }

  public onPage($event) {
    this.searchQuery.offset = $event.offset;
    this.searchQuery.limit = $event.limit;
    this.sendRequest(null);
  }

  getCSSClasses() {
    const v = this.grid.search;
    let cssClasses;
    if (v) {
      cssClasses = 'col-md-6';
    } else {
      cssClasses = 'col-md-9';
    }
    return cssClasses;
  }
}
